import { useEffect, useState } from "react";
const ImageVideoConfig = () => {
    var _a;
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    useEffect(() => {
        window.addEventListener('resize', () => {
            setScreenWidth(window.innerWidth);
        });
    }, [screenWidth]);
    function exitHandler() {
        var video1 = document.getElementById("myVideo1");
        var video2 = document.getElementById("myVideo2");
        var video3 = document.getElementById("myVideo3");
        if (screenWidth < 999) {
            if (!document.fullscreenElement) {
                //capture all element of className video-image-1
                if (video1) {
                    video1.pause();
                    //reset the vdeo to the start
                    video1.currentTime = 0;
                    video1.classList.add("hidden");
                    video1.classList.remove("video-desktop-modal");
                }
                if (video2) {
                    video2.pause();
                    video2.currentTime = 0;
                    video2.classList.add("hidden");
                    video2.classList.remove("video-desktop-modal");
                }
                if (video3) {
                    video3.pause();
                    video3.currentTime = 0;
                    video3.classList.add("hidden");
                    video3.classList.remove("video-desktop-modal");
                }
            }
        }
    }
    document.addEventListener('fullscreenchange', exitHandler, false);
    document.addEventListener('webkitfullscreenchange', exitHandler, false);
    document.addEventListener('mozfullscreenchange', exitHandler, false);
    document.addEventListener('MSFullscreenChange', exitHandler, false);
    //when an element of id svg-close is clicked close the video
    (_a = document.getElementById("svg-close")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", () => {
        const videoIds = ["myVideo1", "myVideo2", "myVideo3"];
        videoIds.forEach(id => {
            const video = document.getElementById(id);
            if (video) {
                video.pause();
                video.currentTime = 0;
                video.classList.add("hidden");
                video.classList.remove("video-desktop-modal");
            }
        });
        const modalVideo = document.getElementsByClassName("modal-video")[0];
        if (modalVideo) {
            modalVideo.classList.add("hidden");
        }
    });
};
export default ImageVideoConfig;
